export const emptyObject = Object.seal({});
export const emptyArray = Object.seal([]);

const set: Set<any> = new Set([]);
export const emptySet = Object.seal(set);

const map: Map<any, any> = new Map();
export const emptyMap = Object.seal(map);
